import React from "react";
import NotFoundImg from "../assets/Image/NoFaq.png";
import { Box, Button, Typography } from "@mui/material";
import styled from "@emotion/styled";

const NoFound = ({
  title = "title",
  message = "message",
  btnText = "btnText",
  handleAction = () => null,
}) => {
  return (
    <Container>
      <Image src={NotFoundImg} />

      <Typography
        fontSize={20}
        color="black"
        textAlign={"center"}
        fontWeight={600}
      >
        {title}
      </Typography>
      <Typography fontSize={14} color="gray" textAlign={"center"}>
        {message}
      </Typography>
      <ActionBtn onClick={handleAction}>{btnText}</ActionBtn>
    </Container>
  );
};

const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "0.7rem",
  alignItems: "center",
}));

const Image = styled("img")(({ theme }) => ({
  width: 90,
  height: 90,
}));
const ActionBtn = styled(Button)(({ theme }) => ({
  backgroundColor: "#E8503A",
  color: "white",
}));

export default NoFound;
